var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTmsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Tms_Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 114.7 49.2",
    style: {
      enableBackground: "new 0 0 114.7 49.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.tms-icon-st0{fill:#CCCCCB;}\r\n\t.tms-icon-st1{fill:#999999;}\r\n\t.tms-icon-st2{fill:#666766;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "tms-icon-st0",
    d: "M44.3,32.6c0-0.1,0-0.3,0-0.4c0,0,0-0.1,0-0.1c-0.1-0.9-0.4-1.8-0.9-2.6l-0.2-0.3c-0.1-0.1-0.1-0.2-0.2-0.3 L32.6,10.7c-0.2,0.6-0.5,1.2-0.8,1.8l-7.5,13l6.5,11.1c1.2,2.1,3.4,3.4,5.6,3.6H37c3.5,0,6.5-2.5,7.2-5.8c0,0,0,0,0,0 c0-0.2,0.1-0.4,0.1-0.6c0-0.1,0-0.1,0-0.2c0-0.2,0-0.3,0-0.5c0-0.1,0-0.2,0-0.3C44.3,32.8,44.3,32.7,44.3,32.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "tms-icon-st1",
    d: "M15.9,10.9l6.3,10.9l6.3-10.9c1.9-3.2,0.9-7.4-2-9.5c-0.1,0-0.1-0.1-0.2-0.1c-0.1-0.1-0.3-0.2-0.4-0.3 c-0.1-0.1-0.2-0.1-0.3-0.2c-0.1-0.1-0.2-0.1-0.3-0.1c-0.1-0.1-0.3-0.1-0.4-0.2c-0.1,0-0.1-0.1-0.2-0.1c-0.2-0.1-0.3-0.1-0.5-0.2 c0,0-0.1,0-0.1,0c-0.2,0-0.3-0.1-0.5-0.1c-0.1,0-0.1,0-0.2,0c-0.2,0-0.3,0-0.5-0.1c-0.1,0-0.2,0-0.3,0c-0.1,0-0.3,0-0.4,0 c-0.1,0-0.3,0-0.4,0c-0.1,0-0.2,0-0.3,0c-0.2,0-0.3,0-0.5,0.1c-0.1,0-0.1,0-0.2,0c-0.2,0-0.4,0.1-0.5,0.1c-0.1,0-0.1,0-0.1,0 c-0.2,0-0.3,0.1-0.5,0.2c-0.1,0-0.1,0-0.2,0.1c-0.1,0.1-0.3,0.1-0.4,0.2c-0.1,0-0.2,0.1-0.3,0.1C18.7,0.9,18.6,1,18.5,1 c-0.1,0.1-0.3,0.2-0.4,0.3c-0.1,0-0.1,0.1-0.2,0.1C14.9,3.6,14,7.7,15.9,10.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "tms-icon-st2",
    d: "M0,32.6c0-0.1,0-0.3,0-0.4c0,0,0-0.1,0-0.1c0.1-0.9,0.4-1.8,0.9-2.6l0.2-0.3c0.1-0.1,0.1-0.2,0.2-0.3 l10.4-18.1c0.2,0.6,0.5,1.2,0.8,1.8l7.5,13l-6.5,11.1c-1.2,2.1-3.4,3.4-5.6,3.6H7.3c-3.5,0-6.5-2.5-7.2-5.8c0,0,0,0,0,0 c0-0.2-0.1-0.4-0.1-0.6c0-0.1,0-0.1,0-0.2c0-0.2,0-0.3,0-0.5c0-0.1,0-0.2,0-0.3C0,32.8,0,32.7,0,32.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "tms-icon-st2",
    d: "M54,10.9h15.9v4h-5.5v16.6h-5V14.9H54V10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "tms-icon-st2",
    d: "M72.5,10.9h5.9l5.8,14.2l5.7-14.2h5.9v20.6h-5V19.1l-4.6,12.3h-4l-4.6-12.4v12.4h-5V10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "tms-icon-st2",
    d: "M106.8,31.7c-4.4,0-7.9-2.2-8-6.4h5.3c0.1,1.6,1.1,2.3,2.6,2.3c1.5,0,2.4-0.7,2.4-1.9 c0-3.8-10.3-1.8-10.2-9.1c0-3.9,3.2-6.1,7.5-6.1c4.5,0,7.5,2.2,7.7,6.2h-5.4c-0.1-1.3-1-2.1-2.4-2.1c-1.2,0-2.1,0.6-2.1,1.9 c0,3.6,10.2,2,10.2,8.9C114.3,28.8,111.6,31.7,106.8,31.7z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTmsIcon);
export default __webpack_public_path__ + "static/media/TmsIcon.f88dc73d.svg";
export { ForwardRef as ReactComponent };